import AskSuntronixAI from "@/components/askai/AskSuntronixAI";

export default function AskAiPage() {
  return (
    <div className="mx-auto max-w-[1400px] space-y-4 pb-10" data-testid="ask-ai-page">
      <div>
        <div className="text-[10px] font-semibold uppercase tracking-[0.14em] text-slate-500">Intelligence</div>
        <h1 className="text-2xl font-bold tracking-tight md:text-3xl">ASK SUNTRONIX AI</h1>
        <p className="mt-1 text-[13px] text-slate-600">Natural language questions are translated into approved, read-only queries that only ever touch your organisation's data.</p>
      </div>
      <AskSuntronixAI />
    </div>
  );
}
